Object.defineProperty(exports, "__esModule", { value: true });
function TermsQuery(key, value) {
    var _a;
    return {
        terms: (_a = {},
            _a[key] = value,
            _a)
    };
}
exports.TermsQuery = TermsQuery;
//# sourceMappingURL=TermsQuery.js.map